'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upgradeCatalogApi = undefined;

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENDPOINT_URL = '/self-service/v2/product-catalog-list';
var portalId = _hubspot2.default.get();

var _cachedGet = void 0;

var upgradeCatalogApi = exports.upgradeCatalogApi = {
  get: function get() {
    if (_cachedGet) {
      return _cachedGet;
    }

    _cachedGet = _apiClient2.default.get(ENDPOINT_URL, {
      query: {
        appAuth: true,
        authPortal: portalId
      }
    });

    return _cachedGet;
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/upgradeCatalogApi.js
// module id = 479
// module chunks = 3 4 5